import { authHeader, handleResponse } from "../helper/auth-header";

export default class CartonService {
  ControllerName = "CartonMaster";

  async GetCarton(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetCarton`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateUpdateCarton(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateCarton`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
